import { Grid } from '@material-ui/core';
import { createTeam, postUpdateTeam } from '@webapps/business';
import {
  Button,
  FormikTextField,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import * as yup from 'yup';

const teamSchema = yup.object().shape({
  label: yup.string(),
});

const NewTeams = ({ close, data, refetch }) => {
  const {
    css,
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { addToast } = useToast();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateCreateTeam,
  } = useMutation(createTeam);

  const {
    isLoading: isLoadingUpdateTeam,
    isSuccess: isSuccessUpdateTeam,
    mutateAsync: mutateUpdateTeam,
  } = useMutation(postUpdateTeam);

  const formik = useFormik({
    initialValues: {
      label: data?.label || '',
    },
    validationSchema: teamSchema,
    onSubmit: async (values) => {
      if (data) {
        await mutateUpdateTeam({
          data: values,
          id: data?.id,
        });
      } else {
        await mutateCreateTeam({
          data: values,
          id: idUser,
        });
      }
    },
  });

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      close();
      refetch();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isSuccessUpdateTeam) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      close();
      refetch();
    }
  }, [isSuccessUpdateTeam]);

  return (
    <div
      className={classes.container}>
      <Grid container xs={12} sm={10}>
        <Grid container>
          <Grid item xs={12} className={css({ width: '100%' })}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Nom de l’équipe (ex: Informatique)"
              name="label"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({ textAlign: 'center', marginTop: spacing(4) })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            disabled={isLoading || isLoadingUpdateTeam}
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Enregistrer
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: spacing(3),
    '@media (max-width:768px)': { margin: spacing(1) }
  }
});

NewTeams.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  data: PropTypes.object,
};

export default NewTeams;
